import { createIcon } from '@chakra-ui/react'

export const AttentionIcon = createIcon({
  displayName: 'AttentionIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 18.3334C12.3012 18.3334 14.3845 17.4007 15.8925 15.8926C17.4006 14.3846 18.3333 12.3012 18.3333 10.0001C18.3333 7.69892 17.4006 5.61558 15.8925 4.10752C14.3845 2.59949 12.3012 1.66675 9.99999 1.66675C7.69882 1.66675 5.61549 2.59949 4.10743 4.10752C2.5994 5.61558 1.66666 7.69892 1.66666 10.0001C1.66666 12.3012 2.5994 14.3846 4.10743 15.8926C5.61549 17.4007 7.69882 18.3334 9.99999 18.3334Z"
        fill="#D82C0D"
        stroke="#D82C0D"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 15.4166C10.5753 15.4166 11.0417 14.9502 11.0417 14.3749C11.0417 13.7996 10.5753 13.3333 10 13.3333C9.42472 13.3333 8.95834 13.7996 8.95834 14.3749C8.95834 14.9502 9.42472 15.4166 10 15.4166Z"
        fill="white"
      />
      <path
        d="M10 5V11.6667"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
})
